import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import tokens from '../../assets/theme/tokens';

export const useFFTableStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: '100%',
    },
    // Framed like a steerage card: hairline border, large radius, faint shadow.
    paper: {
      width: '100%',
      marginBottom: theme.spacing(2),
      border: `1px solid ${tokens.colors.border}`,
      borderRadius: tokens.radius.lg,
      boxShadow: tokens.shadows.sm,
      overflow: 'hidden',
    },
    table: {
      minWidth: 750,
    },
    visuallyHidden: {
      border: 0,
      clip: 'rect(0 0 0 0)',
      height: 1,
      margin: -1,
      overflow: 'hidden',
      padding: 0,
      position: 'absolute',
      top: 20,
      width: 1,
    },
    tableContainer: {
      maxHeight: 'calc(100vh - 300px)',
      overflowY: 'auto',
    },
    filterBar: {
      padding: theme.spacing(2),
      display: 'flex',
      flexWrap: 'wrap',
      alignItems: 'center',
      gap: theme.spacing(2),
    },
    filterItem: {
      minWidth: 200,
      marginRight: theme.spacing(2),
    },
    filterButton: {
      marginLeft: 'auto',
    },
    filtersRow: {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: theme.spacing(2),
    },
    dateRangeContainer: {
      padding: theme.spacing(2),
      display: 'flex',
      alignItems: 'center',
      flexWrap: 'wrap',
    },
    dateRangeLabel: {
      fontWeight: 'bold',
      marginBottom: theme.spacing(1),
      color: theme.palette.primary.main,
    },
    dateRangePicker: {
      width: 200,
    },
    expandIconCell: {
      width: 50,
      padding: theme.spacing(0, 1),
    },
    expandIcon: {
      transition: 'transform 0.3s',
    },
    expandIconRotated: {
      transform: 'rotate(90deg)',
    },
    expandedRow: {
      backgroundColor: theme.palette.action.hover,
    },
    expandedContent: {
      backgroundColor: theme.palette.background.default,
    },
    loadingOverlay: {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: 'rgba(255, 255, 255, 0.7)',
      zIndex: 1,
    },
    emptyState: {
      padding: theme.spacing(4),
      textAlign: 'center',
    },
    errorState: {
      padding: theme.spacing(4),
      textAlign: 'center',
      color: theme.palette.error.main,
    },
    paginationContainer: {
      display: 'flex',
      justifyContent: 'flex-end',
      padding: theme.spacing(2),
    },
    actionButton: {
      marginRight: theme.spacing(1),
    },
    tableRow: {
      cursor: 'default',
      '&:hover': {
        backgroundColor: theme.palette.action.hover,
      },
    },
    tableRowClickable: {
      cursor: 'pointer',
      '&:hover': {
        backgroundColor: theme.palette.action.hover,
      },
    },
    tableCell: {
      padding: theme.spacing(1, 2),
    },
    tableCellHeader: {
      fontWeight: 'bold',
      backgroundColor: theme.palette.background.default,
    },
  })
);
